import { Box, Button, Grid, List, ListItem, ListItemText, Paper, Typography } from '@mui/material';
import { FC } from 'react';

export const NoEudrBanner: FC = () => {
	return (
		<Box sx={{ display: 'flex', justifyContent: 'center' }}>
			<Paper
				sx={{
					margin: '0px 20px 20px 20px',
					padding: '10px 20px 0 20px',
					overflowX: 'auto',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					gap: 1,
					backgroundColor: '#628c5f55',
					borderRadius: '12px',
					p: '20px',
					maxWidth: '1200px',
				}}
			>
				{/* <Notice text="GPSR is a service that provides real-time information about the availability of products in your warehouse." /> */}
				<Grid container spacing={1}>
					<Grid item xs={12} lg={8}>
						<Typography
							variant="h2"
							color="warning.main"
							sx={{ fontSize: '1.4rem', fontWeight: 'bold', mb: 2, color: 'error.dark' }}
						>
							EAS EUDR solution is currently on hold.
							<br />
							The European Commission is in the final stages of confirming a one-year delay to the
							regulation’s implementation.
						</Typography>
						<Typography
							variant="h2"
							color="primary"
							sx={{
								fontSize: '1.3rem',
								fontWeight: 'bold',
								mb: 2,
								color: '#173916',
							}}
						>
							What is the EUDR?
						</Typography>
						<Typography
							component="p"
							color="primary"
							sx={{
								fontSize: '1rem',
								color: '#173916',
							}}
						>
							The <b>EU Deforestation Regulation (EUDR)</b> applies to certain products linked to
							forest and ecosystem use, such as timber, paper and board, leather, rubber, cocoa,
							coffee and related goods. It requires companies to prove that these products are not
							associated with recent deforestation and that full supply-chain information is
							available.
						</Typography>
						<Typography
							component="p"
							color="primary"
							sx={{
								fontSize: '1rem',
								color: '#173916',
							}}
						>
							If you sell these products into the EU, you must meet <b>EUDR</b> due-diligence
							requirements, otherwise you risk product delisting, fines and loss of market access.
						</Typography>
						<Typography
							variant="h2"
							color="primary"
							sx={{
								fontSize: '1.3rem',
								fontWeight: 'bold',
								mt: 3,
								mb: 2,
								color: '#173916',
							}}
						>
							Who Needs to Comply with EUDR?
						</Typography>
						<Typography
							component="p"
							color="primary"
							sx={{
								fontSize: '1rem',
								color: '#173916',
							}}
						>
							Any company placing EUDR-covered products on the EU market, or exporting them from the
							EU, must comply. This includes:
						</Typography>
						<List
							sx={{
								m: '0 0 0 20px',
								p: 0,
								'& .MuiTypography-root': {
									// color: 'primary.main',
									color: '#173916',
								},
								'& .MuiTypography-body1': {
									fontWeight: 'bold',
								},
								'& .MuiListItemText-root': {
									fontSize: '1rem',

									margin: 0,
									padding: 0,
								},
								'& .MuiListItem-root': {
									padding: 0,
								},
								'& .MuiListItem-root + .MuiListItem-root': {
									marginTop: 1,
								},
							}}
						>
							<ListItem>
								<ListItemText
									primary="Manufacturers and Brands"
									secondary="using regulated materials in their products and selling them to EU customers"
								/>
							</ListItem>
							<ListItem>
								<ListItemText
									primary="Importers"
									secondary="bringing covered raw materials or finished goods into the EU market"
								/>
							</ListItem>
							<ListItem>
								<ListItemText
									primary="Publishers, Printers and Packaging Suppliers"
									secondary="using paper, board or other forest-based materials for books, printed items and packaging"
								/>
							</ListItem>
							<ListItem>
								<ListItemText
									primary="Retailers, Online Shops and Marketplaces"
									secondary="selling EUDR-covered products"
								/>
							</ListItem>
						</List>
						<Typography
							component="p"
							color="primary"
							sx={{
								fontSize: '1rem',
								mt: 2,
								color: '#173916',
							}}
						>
							<b>EAS</b> offers an EUDR compliance solution with automated dashboards, supplier
							questionnaires and reporting tools to help you meet your obligations with minimal
							manual work.
						</Typography>
					</Grid>
					<Grid item xs={false} lg={4} display={{ xs: 'none', lg: 'block' }}>
						<img
							src="/img/eas_eudr-2.webp"
							alt=""
							style={{
								width: '100%',
								borderRadius: '12px',
							}}
						/>
					</Grid>
				</Grid>

				<Grid
					container
					spacing={1}
					sx={{
						mt: 2,
						width: '100%',
						color: '#628c5f55',
					}}
				>
					<Grid item xs={12} lg={4}>
						<Button
							variant="contained"
							color="primary"
							href="http://easproject.com/reg"
							target="_blank"
							fullWidth
							sx={{
								color: '#bed0c4',
								backgroundColor: '#173916',
								'&:hover': { backgroundColor: '#173916e0' },
							}}
							// sx={{ width: '100%' }}
						>
							Register for EUDR service
						</Button>
					</Grid>
					<Grid item xs={12} lg={4}>
						<Button
							variant="contained"
							color="primary"
							href="https://easproject.com/schedule-a-meeting-with-eas/"
							target="_blank"
							fullWidth
							sx={{
								color: '#bed0c4',
								backgroundColor: '#173916',
								'&:hover': { backgroundColor: '#173916e0' },
							}}
						>
							Book a meeting
						</Button>
					</Grid>
					<Grid item xs={12} lg={4}>
						<Button
							variant="contained"
							color="primary"
							href="https://easproject.com/eudr/"
							target="_blank"
							fullWidth
							sx={{
								color: '#bed0c4',
								backgroundColor: '#173916',
								'&:hover': { backgroundColor: '#173916e0' },
							}}
						>
							More about EUDR
						</Button>
					</Grid>
				</Grid>
			</Paper>
		</Box>
	);
};
